export enum AcceptInviteFields {
  password = 'password',
  confirmPassword = 'confirmPassword',
}
